import { useMutation } from "react-query";
import { OTPErrorCode, OTPErrorMessage, postAuthVerifyEmail } from "../../../queries/auth";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { setAccessToken } from "../../../lib/auth";
import { trackMixPanelLogin } from "../../../lib/network";
import { useParams } from "react-router-dom";

export function useVerifyEmail({
  onSuccess = () => {},
  onError = () => {},
}: {
  onSuccess?: () => void;
  onError?: (error: unknown, message: string, errorCode: OTPErrorCode | "RATE_LIMIT" | null) => void;
} = {}) {
  const { site } = useParams<{ site: string }>();
  const networkHeaders = useNetworkHeaders();
  const [verifyOTP, { isLoading, error }] = useMutation(postAuthVerifyEmail(networkHeaders), {
    onSuccess: async (data) => {
      setAccessToken(data.token);
      await trackMixPanelLogin(data.token, site, false);
      onSuccess();
    },
    onError: (error) => {
      const errorCode = (error as any).error.errorCode as OTPErrorCode;

      switch ((error as any).status) {
        case 401:
          if (errorCode in OTPErrorMessage) onError(error, OTPErrorMessage[errorCode], errorCode);
          else onError(error, "One-time password is wrong or expired", null);
          break;
        case 429:
          const message = (error as any).error.message;
          onError(error, message, "RATE_LIMIT");
          break;
        default:
          onError(error, "An unknown error occurred while verifying one-time password", null);
          break;
      }
    },
  });

  return { verifyOTP, isLoading, error };
}
